import { RootState } from "@/store/redux/store";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useTransport from "./useTransport";
import useRoadmaps from "./useRoadmaps";
import { setBusStationsShippingFrom, setCitiesTo, setDate, setFormRoadmaps, setRoadmap } from "../store/mapScreenSlce";
import useBusstaitions from "./useBusstaitions";
import useCity from "./useCity";
import { ICity } from "@/shared/types/city";
import { IBusStation } from "@/shared/types/busStaition";
import useFormBusStaitions from "./useFormBusStaitions";
import { removeAfterUnderscore } from "../utils/strokeUtils";
import { formatDateDDMMYYYY } from "../../../utils/dateFunctions";
import { getCitiesFrom, getCitiesTo, getStopsFrom } from "../../../services/GET_FROM_OR_TO/GET_FROM_OR_TO";
import useToastMap from "./useToast";

//! из-за того, что изначально не были известны требования к функционалу приложения в полом размере и появлялись на ходу + нет документации по АПИ = архитектура спроектирована не верно и в состоянии Цейнтнота
//! необходимо переделать, данный хук будет управлять всей логикой работы
function useHandleDataForm() {
    const { mapMode,
        city,
        cities,
        cityTo,
        busStation,
        busStationTo,
        cityRoadmaps,
        date,
        roadmap
    } = useSelector((state: RootState) => state.mapScreen);

    const { openToastMap, hideToastMap } = useToastMap();
    const { getAllTransportOnCity } = useTransport();
    const { selectCityCityRoadmaps, selectCityRoadmaps, selectBusStationCityRoadmaps, getCityRoadmaps } = useRoadmaps();
    const { fetchStaitionsShipping, fillBusStations, fillBusStationsTwoCity, } = useBusstaitions();
    const {
        fillAllCitiesShippingClear,
        fillCitiesShippingFromCity,
        fillCitiesShippingFromStaition,
        fillCitiesShippingFromStaitionTO,
        fillCitiesShippingCity,
        fillCitiesFromAndTo,
    } = useCity();
    const {
        fillStaitionsShippingByStaitionFrom,
        fillStaitionsBehindTwoCities,
        fillAllStaitionsFromAndTo,
        fillStaitionsShippingByArriveStaitionAndCityTo,
        fillBusStationsFromFromCity,
        fillBusStationsToFromCity,
        fillStaitionsShippingFROMTO,
    } = useFormBusStaitions();

    const dispatch = useDispatch()
    const [initCity, setInitCity] = useState<ICity>();
    const [initStaition, setInintStaition] = useState<IBusStation>();
    const [isFetchLoading, setFetchLoading] = useState<boolean>(false);

    // Обновление транспорта на карте 
    useEffect(() => {
        let updateTransportInterval: NodeJS.Timeout;
        if (mapMode === 'roadMaps' && city) {
            setFetchLoading(true)
            getAllTransportOnCity(true, true, () => { setFetchLoading(false) });
            //updateTransportInterval = setInterval(() => getAllTransportOnCity(false, false), 15000);
        } else {
            if (updateTransportInterval) {
                clearInterval(updateTransportInterval);
            }
        }
        return () => {
            if (updateTransportInterval) {
                clearInterval(updateTransportInterval);
            }
        };
    }, [mapMode, city]);

    useEffect(() => {
        if (city) {
            getCityRoadmaps(city.id)
        }
    }, [city])

    async function caseCity(isFillCities = true) {
        setInitCity(city);

        if (cities && cities.length < 1) {
            await fillCitiesShippingCity(); // наполнить для инпута, тк при иницииации страницы список пустой
        }

        console.log('[Режим формы] один город')
        await Promise.all([
            fillCitiesShippingFromCity(city), // в какие города уехать
            fillBusStationsFromFromCity(city), // остановки откуда
            fillBusStationsToFromCity(city, false), // остановки куда
            getCityRoadmaps(city.id),
        ])
    }

    async function caseCityTo() {
        console.log('[Режим формы] один городКуда')

        await Promise.all([
            fillBusStationsToFromCity(cityTo),
            fillBusStationsFromFromCity(cityTo), // остановки откуда
            fillCitiesShippingCity(cityTo)
            //fillBusStations(cityTo, true, mapMode === 'busStops'),
            //fetchStaitionsShipping({ cityToId: cityTo.id.toString(), type: 'TO', date: formatDateDDMMYYYY(date) }),
        ])
    }

    /** город из + остановка из (маршруты не получить - нужны две точки из и до) */
    async function caseCityBusStaition() {
        console.log('[Режим формы] остановка из')
        if (city && city.id !== initCity.id) {
            await caseCity(true);
        }
        await Promise.all([
            fillCitiesShippingFromStaition(busStation.area_id ? busStation.area_id.toString() : busStation.id.toString()),
            fillStaitionsShippingByStaitionFrom(busStation.area_id ? busStation.area_id.toString() : busStation.id.toString(), city.id, false),
        ])
    }

    /** город - город */
    async function caseCityCityTo() {
        if (city.id !== initCity.id) {
            await caseCity(true);
        }
        console.log('[Режим формы] город городКуда', city.id.toString(), cityTo.id.toString())
        await Promise.all([
            fillStaitionsBehindTwoCities(city.id.toString(), cityTo.id.toString()),
            mapMode === 'roadMaps' ? selectCityCityRoadmaps(cityTo?.id) : () => { },
        ])
    }

    /** город из + остановка из + город куда */
    async function caseCityCityToBusStaition() {
        console.log('[Режим формы] город городКуда. ОстановкаОткуда')
        await Promise.all([
            // fillStaitionsShippingByArriveStaitionAndCityTo(
            //     removeAfterUnderscore(
            //         busStation.area_id ?
            //             busStation.area_id.toString()
            //             :
            //             busStation.id.toString().split('_')[0]),
            //     cityTo.id.toString(), city ? city.id.toString() : ''),
            // mapMode === 'roadMaps' ?
            //     selectBusStationCityRoadmaps(busStation.area_id, Number(cityTo.id), true) : () => { },
        ])
    }

    /** чистая форма */
    async function caseClearForm() {
        console.log('[Режим формы] чиста форма');
        try {
            await Promise.all([
                fillAllStaitionsFromAndTo(),
                fillAllCitiesShippingClear()
            ])
        }
        catch (err) {
            console.log(err)
        }
    }

    async function caseFullFill() {
        console.log('[Режим формы] полная форма');
        if (mapMode === 'busStops') {
            //Равно остановка откуда остновка куда
            await fillStaitionsShippingByStaitionFrom(busStation.area_id.toString());
        }
        if (mapMode === 'roadMaps') {
            await selectBusStationCityRoadmaps(busStation.area_id, Number(busStationTo.area_id), false);
        }
    }

    /** только остановка "куда" (без города и без откуда) */
    async function caseBusStationToOnly() {
        console.log('[Режим формы] только остановка КУДА');
        await fillStaitionsShippingFROMTO(busStationTo.area_id.toString());
        await fillCitiesShippingFromStaitionTO(busStationTo.area_id.toString());
    }

    /** город "куда" + остановка "куда" (без откуда) */
    async function caseCityToBusStationTo() {
        console.log('[Режим формы] городКУДА + остановкаКУДА');
        await fillStaitionsShippingFROMTO(busStationTo.area_id.toString());
    }

    /** город "откуда" + остановка "куда" (город "куда" не выбран) */
    async function caseCityBusStationTo() {
        console.log('[Режим формы] городОТКУДА + остановкаКУДА');
        await fillStaitionsShippingFROMTO(busStationTo.area_id.toString());
    }

    /** остановка "откуда" + остановка "куда" (без городов) */
    async function caseBusStationBusStationTo() {
        console.log('[Режим формы] остановкаОТКУДА + остановкаКУДА (заглушка)');
        // TODO: в roadMaps возможно можно сразу selectBusStationCityRoadmaps(area_id, area_id, false)
        // Пока — минимально обновим "куда" от остановки "откуда"
        await fillStaitionsShippingByStaitionFrom(busStation.area_id.toString());
    }

    /** город "откуда" + город "куда" + остановка "куда" (остановка "откуда" не выбрана) */
    async function caseCityCityToBusStationTo() {
        console.log('[Режим формы] городОТКУДА + городКУДА + остановкаКУДА');
        // равно город откуда + остановка куда 
        await fillStaitionsShippingFROMTO(busStationTo.area_id.toString());
    }

    /** остановка "откуда" + город "куда" + остановка "куда" */
    async function caseBusStationCityToBusStationTo() {
        console.log('[Режим формы] остановкаОТКУДА + городКУДА + остановкаКУДА (заглушка)');
        //Равно остановка откуда остновка куда
        await fillStaitionsShippingByStaitionFrom(busStation.area_id.toString());
    }

    const prevParamsRef = useRef({
        city: null,
        cityTo: null,
        busStation: null,
        busStationTo: null,
    });

    async function fill() {
        try {
            openToastMap('loading', 'Загрузка данных')
            const key = [
                city ? '1' : '0',
                busStation ? '1' : '0',
                cityTo ? '1' : '0',
                busStationTo ? '1' : '0',
            ].join('');

            const handlers: Record<string, () => Promise<void> | void> = {
                '0000': caseClearForm, // пустая форма

                // ===== ОТКУДА =====
                '1000': caseCity,              // только город ОТКУДА
                '0100': caseCityBusStaition,   // только остановка ОТКУДА
                '1100': caseCityBusStaition,   // город ОТКУДА + остановка ОТКУДА

                // ===== КУДА =====
                '0010': caseCityTo,            // только город КУДА

                // КУДА-остановка
                '0001': caseBusStationToOnly,  // только остановка КУДА
                '0011': caseCityToBusStationTo,// город КУДА + остановка КУДА

                // ===== ОТКУДА → КУДА =====
                '1010': caseCityCityTo,        // город ОТКУДА → город КУДА
                '0110': caseCityCityToBusStaition, // остановка ОТКУДА → город КУДА
                '1110': caseCityCityToBusStaition, // город+остановка ОТКУДА → город КУДА

                // КУДА-остановка в связке
                '1001': caseCityBusStationTo,      // город ОТКУДА → остановка КУДА
                '0101': caseBusStationBusStationTo,// остановка ОТКУДА → остановка КУДА
                '1101': caseBusStationBusStationTo,// город+остановка ОТКУДА → остановка КУДА

                '1011': caseCityCityToBusStationTo,      // город ОТКУДА + город КУДА + остановка КУДА
                '0111': caseBusStationCityToBusStationTo,// остановка ОТКУДА + город КУДА + остановка КУДА

                // ===== ПОЛНОЕ ЗАПОЛНЕНИЕ =====
                '1111': caseFullFill,          // всё выбрано
            };

            await handlers[key]?.();
        } catch (err) {
            console.log(err);
        } finally {
            hideToastMap();
            setFetchLoading(false);
        }
    }


    useEffect(() => {
        if (mapMode !== 'init') {
            fill();
        }
    }, [date, city, cityTo, busStation, busStationTo, mapMode])

    // Наполнение маршрутов для отображения в форме 
    useEffect(() => { }, [])


    //TODO отдельный хук

    return ({
        isFetchLoading,
    })
}

export default useHandleDataForm;